import { useEffect, useState } from 'react';

import { fetchActiveMembershipExtensionOptions } from 'api/homelesses';
import { ActiveMembershipExtensionOptions } from 'types';

const useActiveMembershipExtensionOptions = (
    memberId: number | null | undefined,
    enabled: boolean
) => {
    const [extensionOptions, setExtensionOptions] =
        useState<ActiveMembershipExtensionOptions | null>(null);
    const [isFetchingExtensionOptions, setIsFetchingExtensionOptions] =
        useState(enabled);
    const [extensionOptionsError, setExtensionOptionsError] = useState(false);

    useEffect(() => {
        if (!enabled || !memberId) {
            setExtensionOptions(null);
            setIsFetchingExtensionOptions(false);
            setExtensionOptionsError(false);
            return;
        }

        let cancelled = false;

        const fetchData = async () => {
            setIsFetchingExtensionOptions(true);
            setExtensionOptionsError(false);

            try {
                const options = await fetchActiveMembershipExtensionOptions(memberId);
                if (cancelled) return;
                setExtensionOptions(options);
            } catch (error) {
                console.error('Error fetching active membership extension options:', error);
                if (!cancelled) {
                    setExtensionOptions(null);
                    setExtensionOptionsError(true);
                }
            } finally {
                if (!cancelled) {
                    setIsFetchingExtensionOptions(false);
                }
            }
        };

        fetchData();

        return () => {
            cancelled = true;
        };
    }, [memberId, enabled]);

    return { extensionOptions, isFetchingExtensionOptions, extensionOptionsError };
};

export default useActiveMembershipExtensionOptions;
